<div *ngIf="model">
    <ms-day-of-race-lobby *ngIf="model.fixtures.length" [dayOfRace]="model" [filter]="tomorrow" [sportId]="sportId"></ms-day-of-race-lobby>
    <ms-error
        *ngIf="!model.fixtures.length"
        [links]="false"
        [message]="sitecore.horseRacing.tournaments.ErrNoTomorrowRaces"
        [severity]="'info'"></ms-error>
</div>
